var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/SessionWatcher/SessionWatcher.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"SessionWatcher\">\n    <div class=\"SessionWatcher-panel\">\n        <div class=\"SessionWatcher-text\">Your session is about to expire and you will be logged out from the site.</div>\n\n        <div class=\"SessionWatcher-buttons\">\n            <div class=\"SessionWatcher-buttons-button SessionWatcher-buttons-button--first\">\n                Stay Logged In\n            </div>\n            <div class=\"SessionWatcher-buttons-button SessionWatcher-buttons-button--second\">\n                Log Out\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/SessionWatcher/SessionWatcher.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SessionWatcher/SessionWatcher.jinja
// module id = 518
// module chunks = 0